import { ILevelGeneralListData, levelGeneralListData } from 'src/app/infrastructure/models/level-general-list-data';
import { IChatListDto, chatListDto } from 'src/assets/common/models/chat-list-dto.g';
import { isEmptyObject } from 'src/app/infrastructure/functions/is-empty-object.function';
import { utcMoment } from 'src/app/infrastructure/functions/zone-day.function';

// Rij in een chatlijst (project-tab of het centrale overzicht op Home). requestedDomainUser_guid = de eigen
// DomainUser in het domain van de chat: daarmee opent de chatpagina (domaincontext). inactive = afgerond.
export const chatListData = {
    ...levelGeneralListData,
    requestedDomainUser_guid: 'requestedDomainUser_guid',
    domain_name: 'domain_name',
    project_name: 'project_name',
    task_subject: 'task_subject',
    subject: 'subject',
    lastMessageOn: 'lastMessageOn',
    lastMessage_body: 'lastMessage_body',
    lastMessage_senderName: 'lastMessage_senderName',
    unreadCount: 'unreadCount',
    isParticipant: 'isParticipant',
    done: 'done',
    closed: 'closed',
} as const;

export type TChatListData = (typeof chatListData)[keyof typeof chatListData];

export interface IChatListData extends ILevelGeneralListData {
    [chatListData.requestedDomainUser_guid]: string | null;
    [chatListData.domain_name]: string | null;
    [chatListData.project_name]: string | null;
    [chatListData.task_subject]: string | null;
    [chatListData.subject]: string | null;
    [chatListData.lastMessageOn]: string | null;
    [chatListData.lastMessage_body]: string | null;
    [chatListData.lastMessage_senderName]: string | null;
    [chatListData.unreadCount]: number;
    [chatListData.isParticipant]: boolean;
    [chatListData.done]: boolean;
    [chatListData.closed]: boolean;
}

export class ChatListData
    implements IChatListData
{
    [chatListData.guid]!: string;
    [chatListData.deleted]: boolean = false;
    [chatListData.inactive]: boolean = false;

    [chatListData.requestedDomainUser_guid]: string | null = null;
    [chatListData.domain_name]: string | null = null;
    [chatListData.project_name]: string | null = null;
    [chatListData.task_subject]: string | null = null;
    [chatListData.subject]: string | null = null;
    [chatListData.lastMessageOn]: string | null = null;
    [chatListData.lastMessage_body]: string | null = null;
    [chatListData.lastMessage_senderName]: string | null = null;
    [chatListData.unreadCount]: number = 0;
    [chatListData.isParticipant]: boolean = false;
    [chatListData.done]: boolean = false;
    [chatListData.closed]: boolean = false;

    private constructor(
        modelListDto?: IChatListDto | null
    )
    {
        if (!modelListDto || isEmptyObject(modelListDto)) return;

        this[chatListData.guid] = modelListDto[chatListDto.guid]!;
        this[chatListData.deleted] = modelListDto[chatListDto.deleted] ?? false;
        this[chatListData.inactive] = modelListDto[chatListDto.inactive] ?? false;

        this[chatListData.requestedDomainUser_guid] = modelListDto[chatListDto.requestedDomainUser_Guid] ?? null;
        this[chatListData.domain_name] = modelListDto[chatListDto.domain_Name] ?? null;
        this[chatListData.project_name] = modelListDto[chatListDto.project_Name] ?? null;
        this[chatListData.task_subject] = modelListDto[chatListDto.task_Subject] ?? null;
        this[chatListData.subject] = modelListDto[chatListDto.subject] ?? null;
        // Zoneloos UTC uit de database → ISO met 'Z', anders toont appDate de tijd als lokale tijd.
        this[chatListData.lastMessageOn] = utcMoment(modelListDto[chatListDto.lastMessageOn])?.toISOString() ?? null;
        this[chatListData.lastMessage_body] = modelListDto[chatListDto.lastMessage_Body] ?? null;
        this[chatListData.lastMessage_senderName] = modelListDto[chatListDto.lastMessage_SenderName] ?? null;
        this[chatListData.unreadCount] = modelListDto[chatListDto.unreadCount] ?? 0;
        this[chatListData.isParticipant] = modelListDto[chatListDto.isParticipant] ?? false;
        this[chatListData.done] = modelListDto[chatListDto.done] ?? false;
        this[chatListData.closed] = modelListDto[chatListDto.closed] ?? false;
    }

    static create(modelListDto?: IChatListDto): ChatListData | null {
        return modelListDto ? new ChatListData(modelListDto) : null;
    }
}
